// extracted by mini-css-extract-plugin
export default {"item":"Item_item__w7Q8t","preview":"Item_preview__h9Y39","number":"Item_number__3jHkG","title":"Item_title__a-f0k","time":"Item_time__4uVH+"};